import { render } from "./ImportProject.vue?vue&type=template&id=947b0d3c"
import script from "./ImportProject.vue?vue&type=script&lang=js"
export * from "./ImportProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__